import { render, staticRenderFns } from "./AlertLocationChange.vue?vue&type=template&id=f305557a&"
import script from "./AlertLocationChange.vue?vue&type=script&lang=js&"
export * from "./AlertLocationChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports